import type { BuyBoxDataFragment } from '@packages/gql/generated/shopping/graphql';

export const buyBoxMockDataMinimal: BuyBoxDataFragment = {
  freeShipping: false,
  targetPage: 'CheckAndOrder',
  subTotal: {
    amount: 0,
    currency: 'EUR',
  },
  saving: null,
  banners: [],
};

export const buyBoxMockDataFull: BuyBoxDataFragment = {
  freeShipping: true,
  targetPage: 'CheckAndOrder',
  subTotal: {
    amount: 5001,
    currency: 'EUR',
  },
  saving: {
    amount: 3020,
    currency: 'EUR',
  },
  banners: [
    {
      type: 'PREMIUM',
      articleNumber: '123456789',
      coupon: '1coupon',
    },
  ],
};
